import { Helmet } from "react-helmet-async";

const SITE_URL = "https://www.tulsigiri.com";
const DEFAULT_IMAGE = "/og-image.jpg";

export default function SEO({ title, description, path = "/", type = "website", image, children }) {
  const canonical = `${SITE_URL}${path}`;
  const ogImage = image || `${SITE_URL}${DEFAULT_IMAGE}`;

  return (
    <Helmet>
      <title>{title}</title>
      <meta name="description" content={description} />
      <link rel="canonical" href={canonical} />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:type" content={type} />
      <meta property="og:url" content={canonical} />
      <meta property="og:image" content={ogImage} />
      <meta property="og:site_name" content="Tulsi Giri" />
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={ogImage} />
      {children}
    </Helmet>
  );
}
